import { render, staticRenderFns } from "./EditExternal.vue?vue&type=template&id=98653726&scoped=true"
import script from "./EditExternal.vue?vue&type=script&lang=js"
export * from "./EditExternal.vue?vue&type=script&lang=js"
import style0 from "./EditExternal.vue?vue&type=style&index=0&id=98653726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98653726",
  null
  
)

export default component.exports